import { Component, forwardRef, OnDestroy, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseInputDirective } from 'gung-common';
import { filter, Subscription } from 'rxjs';
import { UsersService } from '../../../services/users/users.service';

@Component({
  selector: 'lib-assortment-input',
  templateUrl: './assortment-input.component.html',
  styles: [
    '.dropdown-list { max-height: 400px; overflow: auto; width: 100%; }',
    '.form-control > .dropdown { padding-left: 0.75rem; padding-right: 0.75rem; }',
    '.dropdown::after { display: none; }',
    '.item:hover { background-color: #f2f2f2; }'
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AssortmentInputComponent),
      multi: true
    }
  ],
  standalone: false
})
export class AssortmentInputComponent extends BaseInputDirective<string> implements OnInit, OnDestroy {
  searchString = '';
  filteredList: string[] = [];
  showAddNew = false;
  dropdownIsOpen = false;

  protected assortments: string[] = [];
  protected subscription: Subscription;

  constructor(protected usersService: UsersService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.subscription = this.usersService
      .getAllUsersSubject()
      .pipe(filter(users => !!users))
      .subscribe(users => {
        this.assortments = users.map(u => u.assortment);
        this.setSearch(this.searchString);
      });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  setSearch(search: string) {
    this.searchString = (search || '').trim();
    const term = this.searchString.toLowerCase();
    const options = [...new Set([...this.assortments, this.value].filter(a => !!a))].sort();
    this.filteredList = options.filter(a => a.toLowerCase().includes(term));
    this.showAddNew = !!term && !options.some(a => a.toLowerCase() === term);
  }

  selected(item: string) {
    this.value = item;
    this.onTouched();
  }
}
